import { Injectable } from "@angular/core";
import { AuthConfig } from "@tesla/ng-auth";

@Injectable()
export class AppConstants {
  production: boolean;
  ENV: string;
  BASE_URL: string;
  ENV_URL: string;
  openid: AuthConfig;
  PUBLIC_URL: string;
  OPENID_BASEURL: string;
  OPENID_CLIENT_ID: string;
  SupplierPortal_URL: string;
  SRM_UI_URL: string;
  SRM_API_URL: string;
  WSM_URL: string;
  tokenName: string;
  dashboardAppKey: string;
  token: string;
  OTP_URL:  string;
  OTP_CALLBACK_URL:  string;
  MFA_ENROLLMENT_CALLBACK_URL:  string;
  WarpeventsUrl:  string;
  WarpAuthUrl: string;
  WarpDashBoardUrl: string;
  WarpLoginUrl: string;
  WarpLoginClientID: string;
  WarpLoginRedirectUrl: string;
  anlytics_config: string;
}

@Injectable()
export class AppSettings {
    /**
   * Contains the base URL for the application
   */
  constructor(private appConstants: AppConstants) {}
  public Production: boolean = this.appConstants.production;
  public Environment: string = this.appConstants.ENV;
  public EnvironmentUrl: string = this.appConstants.ENV_URL;
  public BaseUrl: string = this.appConstants.BASE_URL;
  public OTP_URL: string = this.appConstants.OTP_URL;
  public OTP_CALLBACK_URL: string = this.appConstants.OTP_CALLBACK_URL;
  public MFA_ENROLLMENT_CALLBACK_URL: string = this.appConstants.MFA_ENROLLMENT_CALLBACK_URL;
  public WarpeventsUrl: string = this.appConstants.WarpeventsUrl;
  public WarpAuthUrl: string = this.appConstants.WarpAuthUrl;
  public WarpDashBoardUrl: string = this.appConstants.WarpDashBoardUrl;
  public WarpLoginUrl: string = this.appConstants.WarpLoginUrl;
  public WarpLoginClientID: string = this.appConstants.WarpLoginClientID;
  public WarpLoginRedirectUrl: string = this.appConstants.WarpLoginRedirectUrl;
  public token: string = this.appConstants.token;
  public PUBLIC_URL: string = this.appConstants.PUBLIC_URL;
  public SRM_UI_URL: string = this.appConstants.SRM_UI_URL;
  public SRM_API_URL: string = this.appConstants.SRM_API_URL;
  public WSM_URL: string = this.appConstants.WSM_URL;
  public tokenName: string = this.appConstants.tokenName;
  public dashboardAppKey: string = this.appConstants.dashboardAppKey;
  public openid: AuthConfig = this.appConstants.openid;

  /**
   * Contains the Supplier Portal Public Url.
   */
  public SupplierPortalUrl: string = this.appConstants.SupplierPortal_URL;

  /**
   * Okta preview base url.
   */
  public OpenId_BaseUrl: string = this.appConstants.OPENID_BASEURL;

  /**
   * Contains the base URL for Warp Login
   */
  public OpenId_OAuthBaseUrl: string =this.OpenId_BaseUrl.replace(/\/$/, "") + "/oauth2/v1/";

  /**
   * Contains the base URL for Warp Login
   */
  public OpenId_AuthorizationUrl: string = this.OpenId_OAuthBaseUrl.replace(/\/$/, "") + "/authorize";

  /**
   * Warp Login Client ID
   */
  public OpenId_ClientID: string = this.appConstants.OPENID_CLIENT_ID;

  /**
   * Warp Login Callback Url to confirm authentication.
   */
  public OpenId_RedirectUrl: string = this.BaseUrl.replace(/\/$/, "") + "/auth/callback"
}

